import { get } from "lodash";
import { PRODUCTION } from "@irati/utils/constants/environment";
import env from "@irati/utils/env";
import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
var SERVICE = "insights";
var PERKBOX_PROD_TENANT = "62887548-427e-4677-912e-6fa6fc950f2f";
var PERKBOX_PROD_USER_EMAIL_WHITELIST = [
    "ben.leeds@perkbox.com",
    "bill.hewitt@perkbox.com",
    "gautam.sahgal@perkbox.com",
    "louise.jones@perkbox.com",
    "madlena.pozlevic@perkbox.com",
    "saurav.chopra@perkbox.com",
    "arif.shanji@perkbox.com",
    "james.arnall@perkbox.com",
    "rob.gorle@perkbox.com",
    "joel.tobias@perkbox.com",
    "mona.akiki@perkbox.com",
    "ed.ellis@perkbox.com",
    "marissa.white@perkbox.com",
    "jennifer.sitruk@perkbox.com",
    "jack.beldon@perkbox.com",
    "deborah.knight@perkbox.com"
];
export default {
    get: function (token, auth) {
        var insightsEnabled = getPermissions(token, SERVICE, ["surveys"], ["read", "create", "update"]);
        var userSurveys = getPermissions(token, SERVICE, ["userSurveys"], ["read"]);
        /**
         * Perkbox hotfix IN-430
         *
         * A lot of Perkbox employees have the admin role enabled, this gives them access to the insights dashboard which
         * could potentially contain sensitive data. A potential long term solution to this is to introduce product level
         * user role permissions.
         *
         * This code block will override the product permissions for the perkbox tenant on production only. If the logged
         * in user isn't one of the whitelisted users
         *
         * auth.featureFlags.featureFlag (auth: ../../types/Auth)
         * @todo re-address once permissions have been updated
         */
        var isProductionEnvironment = env.ENVIRONMENT_NAME === PRODUCTION;
        var isPerkboxTenant = get(token, "claims.ten") === PERKBOX_PROD_TENANT;
        var isWhiteListedPerkboxProdUser = PERKBOX_PROD_USER_EMAIL_WHITELIST.indexOf(get(token, "claims.usr", "").toLowerCase()) >= 0;
        if (isProductionEnvironment && isPerkboxTenant && !isWhiteListedPerkboxProdUser) {
            return omitEmpty({ userSurveys: userSurveys });
        }
        /** Set all permissions true or false */
        var permissions = {
            userSurveys: userSurveys,
            surveys: insightsEnabled,
            schedules: getPermissions(token, SERVICE, ["schedules"], ["read", "create", "update"]),
            questionOverrides: getPermissions(token, SERVICE, ["questionOverrides"], ["read", "update"]),
            /** Feature flag permissions */
            wizard: insightsEnabled,
            reports: insightsEnabled,
            heatmap: insightsEnabled,
            bookmarkComments: insightsEnabled,
            changeOverTime: insightsEnabled,
            customSurvey: insightsEnabled,
            chatroom: auth.featureFlags.isInsChatroomEnabled
        };
        return omitEmpty(permissions);
    }
};
